"use strict";
/**
 * @module Services.Control
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionEventListenerRegistrationRequestSerialiser = exports.SessionEventListenerRegistrationRequestSerialiserClass = void 0;
var conversation_id_serialiser_1 = require("./../../conversation/conversation-id-serialiser");
var Codec = require("./../../io/codec");
var serialiser_1 = require("./../../serialisers/serialiser");
var Long = require("long");
/**
 * Serialiser for {@link SessionEventListenerRegistrationRequest}
 */
var SessionEventListenerRegistrationRequestSerialiserClass = /** @class */ (function (_super) {
    __extends(SessionEventListenerRegistrationRequestSerialiserClass, _super);
    function SessionEventListenerRegistrationRequestSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Write a {@link SessionEventListenerRegistrationRequest} to the stream
     *
     * @param bos   the output stream
     * @param value the {@link SessionEventListenerRegistrationRequest} to be written
     */
    SessionEventListenerRegistrationRequestSerialiserClass.prototype.write = function (bos, value) {
        Codec.writeBoolean(bos, value.isClusterAware);
        Codec.writeOptional(bos, value.sessionFilter, Codec.writeString);
        Codec.writeOptional(bos, value.requestedProperties, function (bos, requestedProperties) {
            Codec.writeCollection(bos, __spreadArray([], __read(requestedProperties.values())), Codec.writeString);
        }, function (requestedProperties) {
            return (requestedProperties !== null &&
                requestedProperties !== undefined &&
                requestedProperties.size > 0);
        });
        Codec.writeOptional(bos, value.sessionStartTime, Codec.writeInt64, function (sessionStartTime) {
            return (sessionStartTime !== null &&
                sessionStartTime !== undefined &&
                Long.fromValue(sessionStartTime) !== Long.ZERO);
        });
        conversation_id_serialiser_1.CIDSerialiser.write(bos, value.conversationId);
    };
    return SessionEventListenerRegistrationRequestSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.SessionEventListenerRegistrationRequestSerialiserClass = SessionEventListenerRegistrationRequestSerialiserClass;
/**
 * The {@link SessionEventListenerRegistrationRequestSerialiser} singleton
 */ // eslint-disable-next-line @typescript-eslint/naming-convention
exports.SessionEventListenerRegistrationRequestSerialiser = new SessionEventListenerRegistrationRequestSerialiserClass();
